import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import type { ResEoirCaseDetailQuery } from './types'

export const getCaseEoirDetailQuery = (alienNumber: string) =>
  queryOptions({
    queryKey: ['case-eoir', { alienNumber }],
    queryFn: (): Promise<ResEoirCaseDetailQuery> => {
      return w.url(`${API_ENDPOINTS.business.v1.case.eoir.index}/${alienNumber}`).get().json()
    },
    retry: false,
  })
